import { useState } from "react";
import { useAppDispatch } from "../../../stores/hooks/hooks.ts";
import { useForm, SubmitHandler } from "react-hook-form";
import { forgotPassword } from "../../../stores/thunks/userAuthThunk.tsx";
import { UserForgotPasswordBodyType } from "../../../stores/types/userAuthTypes.tsx";
import { RevButton, RevInput, RevLink } from "@revmatics/catalyst";
import Logo from "/images/logo.svg";

type ForgotPasswordFormData = UserForgotPasswordBodyType;

export const ForgotPasswordPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ForgotPasswordFormData>({
    mode: "onSubmit",
  });

  const dispatch = useAppDispatch();

  const onFormSubmit: SubmitHandler<ForgotPasswordFormData> = (data) => {
    setIsSubmitting(true);
    dispatch(
      forgotPassword({
        body: data,
        callback: () => {
          setIsSubmitting(false);
          setValue("email", "");
        },
      }),
    );
  };

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="w-full space-y-4"
        noValidate
      >
        <div className="mb-4 flex justify-start">
          <img src={Logo} alt="Company Logo" className="h-[35px] w-auto" />
        </div>
        <h3>Forgot your password?</h3>
        <p className="typography-body-sm">
          Enter your email address below to receive instructions to reset your
          password.
        </p>
        <RevInput
          name="email"
          label="Business email"
          type="email"
          placeholder="Your business email"
          size="md"
          required
          register={register("email", {
            required: "Business email is required.",
            pattern: {
              value: /^\S+@\S+\.\S+$/,
              message: "Entered value does not match email format.",
            },
          })}
          error={errors.email}
          enableClearButton={true}
          onClear={() => setValue("email", "", { shouldValidate: true })}
        />
        {errors.root?.serverError && (
          <div className="mt-2 text-left">
            <p className="text-xs text-red-500">
              {errors.root.serverError.message}
            </p>
          </div>
        )}
        <RevButton
          type="submit"
          variant="primary"
          text="Send reset instructions"
          className="w-full"
          isLoading={isSubmitting}
          displayAs="button"
        />
        <div className="flex items-baseline gap-2">
          <p className="typography-body-sm">Back to</p>
          <RevLink
            linkFontSize="medium"
            text="Login"
            pathname="/signin"
            underline={false}
          />
        </div>
      </form>
    </div>
  );
};
